import React, { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import { Button } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import RewardsAPI from 'api/faber/RewardsAPI'
import OrbitSession from 'hooks/useCookies'

const headers = [
  { label: 'Promo Code', key: 'promocode' },
  { label: 'Distributor ID', key: 'distributorId' },
  { label: 'Reward Product ID', key: 'rewardProductId' },
  { label: 'Distributor Prefix', key: 'distributorPrefix' },
  { label: 'Batch Prefix', key: 'batchPrefix' },
  { label: 'Summary', key: 'promocodeSummary' },
  { label: 'Max Claims', key: 'maxClaims' },
  { label: 'Max Consumption', key: 'maxConsumption' },
  { label: 'Validity Start', key: 'validityStartAt' },
  { label: 'Validity End', key: 'validityEndAt' },
  { label: 'Created By', key: 'createdBy' },
  { label: 'Date Generated', key: 'createdAt' }
]

export default function GenerateTrialCodes() {
  const faberToken = OrbitSession.get('faberToken')
  const [csvData, setCsvData] = useState([])
  const csvDownloadRef = useRef<CSVLink | null>(null)

  const { mutate: generateTrialCodes, isLoading } = useMutation({
    mutationFn: () => RewardsAPI.generateDistributorTrialCodes(faberToken),
    onSuccess(data) {
      const csvData = data.map(
        ({ CreatedAt, validityStartAt, validityEndAt, ...item }) => ({
          ...item,
          validityStartAt: new Date(validityStartAt).toLocaleString(),
          validityEndAt: new Date(validityEndAt).toLocaleString(),
          createdAt: new Date(CreatedAt).toLocaleString()
        })
      )
      setCsvData(csvData)
    }
  })

  // Trigger download when csvData is updated
  useEffect(() => {
    if (csvData.length > 0 && csvDownloadRef.current) {
      // @ts-expect-error Someone did this
      csvDownloadRef.current.link.click()
    }
  }, [csvData])

  return (
    <div className='flex flex-col items-center space-y-4'>
      <Button
        variant='outlined'
        onClick={() => generateTrialCodes()}
        disabled={isLoading}
      >
        {isLoading ? 'Generating...' : 'Generate Trial Codes'}
      </Button>

      <CSVLink
        headers={headers}
        data={csvData}
        filename='Generated-Trial-Codes.csv'
        className='hidden'
        // @ts-expect-error Someone did this
        ref={csvDownloadRef}
      />
    </div>
  )
}
